import { useLocation, useParams } from "react-router-dom";
import DetailPresenter from './DetailPresenter';
import { HeaderMenuList } from '../../assets/datas/ConstantLists';
import { useEffect, useState } from "react";

const DetailContainer = () => {
  const { menu } = useParams();
  const location = useLocation();
  const [color, setColor] = useState<string>("#ffffff");
  // const type = location.hash ? location.hash.split("#")[1] : "information";
  const type = location.state?.type 
    || location.state?.data.children[0].path
    || HeaderMenuList.find(
      menu => menu.path === location.pathname.split("/")[1]
    ).children[0].path;
  const data = location.state?.type ? 
    location.state?.data 
    ?? HeaderMenuList.find(
      menu => menu.path === location.pathname.split("/")[1]
    ).children.find(i => i.path === type)
    : location.state?.data.children[0]
    || HeaderMenuList.find(
      menu => menu.path === location.pathname.split("/")[1]
    ).children.find(i => i.path === type);


//   const menuPath = location.pathname.split("/")[1];
//
//   let matchedMenu =
//       HeaderMenuList.find(menu => menu.path === menuPath) ||
//       HeaderMenuList.find(menu => menu.children?.some(child => child.path === menuPath));
//
//   const type =
//       location.state?.type ||
//       location.state?.data?.children?.[0]?.path ||
//       location.state?.data?.children?.[1]?.path ||
//       matchedMenu?.children?.find(child => child.path === menuPath)?.path ||
//       matchedMenu?.children?.[0]?.path ||
//       matchedMenu?.children?.[1]?.path ||
//       "info";
//
//     const data = location.state?.data
//       || matchedMenu?.children?.find(child => child.path === type)
//       || matchedMenu?.children?.[0]
//       || matchedMenu?.children?.[1];

  useEffect(() => {
    if(type === "automation") {
      setColor("#121212");
    } else {
      setColor("#ffffff");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  return (
      <DetailPresenter
        type={type}
        data={data}
        color={color}
      />
  );
};

export default DetailContainer;